export const SET_WISHROUTE_FOCUS_DATA = 'SET_WISHROUTE_FOCUS_DATA'
export const SET_WISHROUTE_OPTION_DATA = 'SET_WISHROUTE_OPTION_DATA'
export const RESET_WISHROUTE_OPTION_DATA = 'RESET_WISHROUTE_OPTION_DATA'
export const SET_WISHROUTE_PHONE = 'SET_WISHROUTE_PHONE'
export const DELETE_WISHROUTE_DATA = 'DELETE_WISHROUTE_DATA'
export const SET_WISHROUTE_SIGNUP = 'SET_WISHROUTE_SIGNUP'
export const SET_WISHROUTE_SIGNUP_PROCESSING = 'SET_WISHROUTE_SIGNUP_PROCESSING'
export const SET_WISHROUTE_SIGNUP_DATA = 'SET_WISHROUTE_SIGNUP_DATA'

export function setWishrouteFocusData (value) {
  return {
    type: SET_WISHROUTE_FOCUS_DATA,
    payload: value,
  }
}

export function setWishrouteOptionData (value) {
  return {
    type: SET_WISHROUTE_OPTION_DATA,
    payload: value,
  }
}

export function resetWishrouteOptionData () {
  return {
    type: RESET_WISHROUTE_OPTION_DATA,
  }
}

export function deleteWishrouteData () {
  return {
    type: DELETE_WISHROUTE_DATA,
  }
}

export function setWishroutePhone (value) {
  return {
    type: SET_WISHROUTE_PHONE,
    payload: value,
  }
}

export function setWishrouteSignup () {
  return {
    type: SET_WISHROUTE_SIGNUP,
  }
}

export function setWishrouteSignupProcessing (value) {
  return {
    type: SET_WISHROUTE_SIGNUP_PROCESSING,
    payload: value,
  }
}

export function setWishrouteSignupData (data, processing = false) {
  return {
    type: SET_WISHROUTE_SIGNUP_DATA,
    payload: { data, processing },
  }
}
